import "../scss/styles.scss";

import { module1 } from "./modules/module1";

const afterLoad = () => {
  module1.init();
};

document.addEventListener("DOMContentLoaded", afterLoad);
